import { useEffect, useState } from "react";
import { LayersControl, MapContainer, TileLayer } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import { TPMap, TPMapGroup } from "../interfaces/TPMap";
import { getMapByHashcode } from "../services/TPMap";
import MapsGroupItemsRender from "./maps/MapsGroupItemsRender";

interface MapsEmbedProps {
    hashcode: string;
    zoom: number;
    height: number;
}

export default function MapsEmbed(props: MapsEmbedProps) {
    const [map, setMap] = useState<TPMap>();

    const mapHeight = props.height + 'px';

    useEffect(() => {
        if (props.hashcode) {
            getMapByHashcode(props.hashcode)
                .then(response => {
                    if (response.status == 200) {
                        return response.json();
                    } else {
                        alert('Error getting map.');
                    }
                })
                .then(data => {
                    if (data.status == -1) {
                        alert(data.message);
                    } else {
                        setMap(data.data);   
                    }
                });
        }
    }, []);

    return (
        <div className="App">
            <MapContainer center={ [41.3461522, 1.6938175] } zoom={ props.zoom ?? '13' } scrollWheelZoom={false}
                 style={{ minHeight: mapHeight }}>
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                { map && map.groups.length &&
                    <LayersControl position="topright">
                        { map.groups.map((g: TPMapGroup) => {
                            if (g.items.length > 0) {
                                return (<LayersControl.Overlay key={ 'group-' + g.id } name={ g.name } checked={ true }>
                                        <MapsGroupItemsRender items={ g.items } />
                                    </LayersControl.Overlay>);
                                }
                            })
                        }
                    </LayersControl>
                }
            </MapContainer>
        </div>
    )
}    